import { render, staticRenderFns } from "./BottomText.vue?vue&type=template&id=dfe044d0&scoped=true"
import script from "./BottomText.vue?vue&type=script&lang=js"
export * from "./BottomText.vue?vue&type=script&lang=js"
import style0 from "./BottomText.vue?vue&type=style&index=0&id=dfe044d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe044d0",
  null
  
)

export default component.exports